import { Component, EventEmitter, inject, Input, OnChanges, Output, Signal, SimpleChanges } from '@angular/core';
import { OrderItem, OrderPublic } from '../../../../globalTypes/order.types';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { Status } from '../../../../globalTypes/base.types';
import { InteractionView } from '../../../../globalTypes/interactions.types';
import { Fulfillment, FulfillmentStatusType, Parcel, ShippingDistanceUnit, ShippingWeightUnit } from '../../../../globalTypes/fulfillment.types';
import { InteractionEntryComponent } from "../../component/layout/element/interaction-entry.component";
import { ButtonComponent, ButtonDisplay } from "../../component/layout/element/button.component";
import { MatIcon } from "@angular/material/icon";
import { Base } from '../../component/wrapper/base-wrapper.component';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { lastValueFrom, take, takeUntil } from 'rxjs';
import { accountFeature } from '../../store/account.store';
import { snackBarError } from '../../helper/error.handling';
import { respondToFaultyClaim, RespondToFaultyClaimVariables, sendMessage, SendMessageVariables, upsertParcelDimensions, UpsertParcelDimensionsVariables } from '@dataconnect/account';
import { NameTagComponent } from "../../component/layout/element/name.tag.component";
import { CurrencyPipe, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OrderService } from '../../services/order.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { interactionsFeature, InteractionsPageActions } from '../../store/interactions.store';
import { CdkDrag, CdkDragDrop, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop'
import { v4 as uuidV4 } from 'uuid';
import { MatDialog } from '@angular/material/dialog';
import { ManageParcelData, ManageParcelDialogComponent } from './manage.parcel.dialog';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { httpsCallable } from 'firebase/functions';
import { onCallFunctions, UpdateFulfillmentsBeforeShippingVariables } from '../../../../globalTypes/backend.api.types';
import { Functions } from '@angular/fire/functions';
import { MatButton } from "@angular/material/button";
import { GetShippingRateInfoVariables } from '../../../../globalTypes/onCall.types';
import { GetShippingRateInfoData } from '../../../../globalTypes/thirdPartyTypes';
import { RefundDetails, RefundDetailsFaultyClaimResponse } from './refund-details';
import { CancelOrderData, RefundPublic, StartRefundResult } from '../../../../globalTypes/refund.types';
import { CompleteReturnData } from '../../../../functions/src/fulfillment/complete.return';
import { ConfirmDeleteDialogComponent, ConfirmDeleteDialogData } from '../../helper/confirm.delete.dialog';
import { ReviewForEdit } from '../../../../globalTypes/review.types';
import { ReviewTileComponent } from "../../component/review/review.tile";
import { LOCATION_LABEL } from '../../../../globalTypes/configs';


@Component({
  selector: 'msh-fulfillment-order-details',
  imports: [InteractionEntryComponent, RefundDetails, CdkDrag, FormsModule, CurrencyPipe, ButtonComponent, MatIcon, NameTagComponent, CdkDropList, CdkDropListGroup, MatButton, ReviewTileComponent],
  template: `

  @if(!order){
    <div class="null my-5">Searching for order details</div>
  } @else {
    @if(location.id){
    }
    <div class="flex justify-between items-center mb-12">
      <msh-name-tag
        [label]="locations[order.buyerId].name"
        [url]="locations[order.buyerId].profileImage?.url"
        size="small"
      ></msh-name-tag>
    </div>
    @if(managementMode && managementModeNeeded){
      <div>
        <div [class]="'flex items-center gap-4 mb-12 ' + (managementMode !== 'Manage' && !savingFulfillmentUpdates ? 'justify-between' : 'justify-center')">
          @if(managementMode !== 'Manage' && !savingFulfillmentUpdates) {<msh-button [stealthMode]="true" cta="Cancel" (click)="manageParcelConfiguration(true)"></msh-button>}
          <msh-button [stealthMode]="managementMode === 'Manage' || savingFulfillmentUpdates" [disabled]="unregisteredParcelCount > 0" [isLoading]="savingFulfillmentUpdates" (click)="manageParcelConfiguration()" [cta]="(managementMode == 'Manage' ? 'Change Parcel' : 'Save' ) + ' Configuration' + (fulfillments.length === 1 ? '':'s')"></msh-button>
        </div>
        @if(unregisteredParcelCount > 0){
          <div class=" text-center text-sm italic m-2">({{unregisteredParcelCount}} new parcel{{unregisteredParcelCount > 1 ? 's' : ''}} to be created before saving)</div>
        }
      </div>
    }
    <div cdkDropListGroup [class]="managementMode === 'Activate' ? 'dnd' : ''">
    @if(fulfillments){
      @for(fulfillment of fulfillments; track fulfillment.id; let fulfillmentIdx = $index){
        <!-- TODO if fulfillment is completed, ignore -->
        @if((fulfillment.statusId !== "archived" || managementMode === 'Activate') && { 
          parcels: fulfillment.parcels_on_fulfillment, 
          isAllDigital: fulfillment.parcels_on_fulfillment.every(parcel => parcel.orderItems_on_parcel.every(item => item.isDigitalDownload)),
          emptyFulfillment: fulfillment.parcels_on_fulfillment.length === 0 || fulfillment.parcels_on_fulfillment[0].orderItems_on_parcel.length === 0 
          }; as fObj
        ){
          <div class=" mt-4 mb-16">
            <div class=" mt-4 flex flex-col flex-wrap">
              <div [class]="' flex flex-col grow ' + (managementMode === 'Activate' && fulfillment.trackingNumber ? ' opacity-50' : '')">
                <div class=" text-right mr-4 font-bold flex items-center justify-end gap-2">
                  Fulfillment #{{fulfillment.fulfillmentNumber}}
                </div>
                
                @for(parcel of fObj.parcels; track parcel.id; let parcelIdx = $index ){
                  <div class=" mx-4 my-0 flex gap-4 bg-back">

                    <div [class]="' min-w-0 md:min-w-40 ' + ( fObj.emptyFulfillment || parcel.refundId ? ' opacity-50' : '')  ">
                      @if(fObj.isAllDigital){
                        <div class=" text-sm font-bold mb-2">No Physical Items</div>
                      } @else if(parcel.name === '_is_new_'){
                        <div class=" text-sm font-bold mb-2">New Parcel</div>
                        <div class=" text-xs lil-action" (click)="manageParcel(parcel, fulfillment.id, true)">create</div>
                      } @else {
                        @if(parcel.refundId){
                          <div class=" text-sm font-bold mb-2">Return Parcel</div>
                        }@else {
                          <div class=" text-sm font-bold mb-2">
                            {{parcel.name === '_is_new_' || !parcel.name ? 'Parcel ' + fulfillment.fulfillmentNumber + '-' + (parcelIdx + 1) : parcel.name}}
                          </div>
                        }
                        <div class=" text-xs">Dimensions: </div>
                        <div class=" text-xs">{{parcel.length}} x {{parcel.width}} x {{parcel.height}} {{parcel.distanceUnit}}</div>
                        <div class=" text-xs">Weight: {{parcel.weight}} {{parcel.weightUnit}}</div>
                        @if(!fulfillment.trackingNumber && !fObj.emptyFulfillment){
                          <div class=" text-xs lil-action" (click)="manageParcel(parcel, fulfillment.id, false)">edit</div>
                        }
                      }

                    </div>
                    <div [class]="( parcel.orderItems_on_parcel.length == 0 ? ' opacity-50' : '') 
                      + ( managementMode !== 'Activate' || fulfillment.trackingNumber ? ' border-back' : ' msh-drop-list cursor-move border-copy ')
                      + ' flex flex-col grow border-2 rounded-md mb-4 min-h-24 relative'
                      "
                      cdkDropList 
                      [cdkDropListData]="parcel.orderItems_on_parcel"
                      (cdkDropListDropped)="onDrop($event)"
                    >
                          <!-- TODO: make work with multiple parcels : update to orderItems_on_parcel -->
                      @if(parcel.orderItems_on_parcel; as items){
                        @for(item of items; track item.id){
                          <div [class]="' m-2 flex gap-4 '" cdkDrag [cdkDragDisabled]="managementMode !== 'Activate' && !fulfillment.trackingNumber ">
                            <div class=" w-16 h-16 mr-6 rounded bg-white flex items-center justify-center overflow-hidden msh-item-image">
                              <!-- TODO: HANDLE image === null -->
                              @if(item.listingVariation.image){
                                <img 
                                  [src]="item.listingVariation.image.url"
                                  class=""
                                />
                              }
                            </div>
                            <div>
                              <div class=" font-bold">{{item.listingVariation.listing.name}}</div>
                              <div class=" text-sm">{{item.listingVariation.name}}</div>
                              <div class=" text-sm">{{item.listingVariation.description}}</div>
                              <div class=" text-sm font-bold">{{item.pricePerItemAtTimeOfOrder * item.quantity | currency}}</div>
                            </div>
                          </div>
                        }
                        @if(items.length === 0 && !parcel.refundId){
                          <div class=" absolute w-full hover:opacity-0 top-4 flex flex-col items-center justify-center text-center">
                            <div class=" text-sm font-bold mb-2">Unused fulfillment record</div>
                            <div class=" text-xs">Drag an item in to </div>
                            <div class=" text-xs">reinstate this fulfillment</div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
                <!-- End parcel loop -->
                <!-- Add new parcel drop zone -->
                @if(managementMode === 'Activate' && !fulfillment.trackingNumber){
                <!-- TODO maybe make this drop zone so that it only shows on hover -->
                  <div class=" m-4 mb-0 flex gap-4 bg-back">
                    <div class="min-w-0 md:min-w-40">
                    </div>
                    @if(fulfillments.length > 1 && (fulfillment.parcels_on_fulfillment.length === 0 || fulfillment.parcels_on_fulfillment[0].orderItems_on_parcel.length > 0)){
                      <div [class]="'opacity-50 '+ ( managementMode === 'Activate' ? ' border-copy cursor-move ' : ' border-back' ) + ' flex flex-col grow border-2 relative min-h-24 rounded-md mb-4 msh-drop-list'"
                        cdkDropList 
                        [cdkDropListData]="fulfillmentParcelsToAdd[fulfillment.id]"
                        (cdkDropListDropped)="onDrop($event, fulfillment)"
                      >
                        <div class=" absolute w-full hover:opacity-0 top-4 min-w-28 flex flex-col items-center justify-center text-center">
                          <div class=" text-sm font-bold mb-2">Parcel: New Parcel</div>
                          <div class=" text-xs">Drag an item in to </div>
                          <div class=" text-xs">add an additional parcel</div>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- End add new parcel drop zone -->
              </div>
              @if(managementMode !== 'Activate'){
                <div class=" flex gap-4 flex-col self-end text-right justify-between">
                  @if(fulfillment.trackingNumber){
                    <div class=" text-sm" target="_blank">Tracking #<a href="{{fulfillment.trackingUrl}}" class=" text-orange-400">{{fulfillment.trackingNumber}}</a></div>
                  }@else {
                    @if(fulfillment.shipmentIsBeingReconfigured){
                      <div class="flex text-xs items-center justify-end gap-2">
                        <mat-icon class=" text-red-400">error</mat-icon> New shipping rate required
                      </div>
                    } @else if(fObj.isAllDigital){
                        <div class=" uppercase text-xs">Digital Fulfillment</div>
                    } @else {
                      <div class=" uppercase text-xs">Shipping rate: {{fulfillment.rateCost || fulfillment.rateCharged | currency}}</div>
                    }
                  }
                  <div class="justify-end relative my-3">
                    @if(fulfillment.statusId && ctaMap[fulfillment.statusId]){
                      <msh-button (click)="actionButtonClicked(fulfillment)" 
                        [isLoading]="takingAction"
                        [disabled]="fObj.emptyFulfillment"
                        [buttonDisplayMap]="ctaMap[fulfillment.statusId]"
                        [optionData]="{fulfillment, order}"
                      ></msh-button>
                    }
                  </div>
                </div>
              }
            </div>
            <msh-refund-details [loading]="markAsReceivedLoading" [sellerView]="true" [fulfillment]="fulfillment" [fulfillmentStatusMap]="fulfillmentStatusMap" (markRefundAsReceived)="markAsReceived($event)" (respondToFaultyClaim)="respondToFaultyClaim($event)"></msh-refund-details>
            @if(fulfillment.reviews_on_fulfillment && fulfillment.reviews_on_fulfillment.length > 0 ){
              <div class=" flex items-center justify-around mt-4">
                @if(buyerReviews[fulfillment.id]; as review){
                  <msh-review-tile 
                    class="w-5/12"
                    [review]="review"
                    (click)="onOpenReviewDialog.emit(review)"
                  ></msh-review-tile>
                }@else { <div class="null">No review from buyer yet</div> }
                @if(sellerReviews[fulfillment.id]; as review){
                  <msh-review-tile 
                    class="w-5/12"
                    [review]="review"
                    (click)="onOpenReviewDialog.emit(review)"
                  ></msh-review-tile>
                }@else { <div class="null">Review about the buyer needed</div> }
              </div>
            }
            @if(interactions()[fulfillment.id] && managementMode !== 'Activate' && interactions()[fulfillment.id]; as interaction){
              <div class="ml-32">

                  <div (click)="toggleInteraction(fulfillment.id)" 
                    class=" cursor-pointer font-bold flex items-center justify-end text-orange-400 text-right"
                    style="margin-right: 6px;"
                  >
                    <div>{{ fulfillmentStatusMap[fulfillment.statusId] ? fulfillmentStatusMap[fulfillment.statusId].label : fulfillment.statusId}}</div>
                    <div class=" py-2 min-w-8 flex items-center">
                      @if(gettingInteractionsMap[fulfillment.id]){
                        <div class="msh-loading-sm orange">&nbsp;</div>
                      }@else{
                        <mat-icon>{{interactions()[fulfillment.id] && interactions()[fulfillment.id].show ? 'expand_less' : 'expand_more'}}</mat-icon>
                      }
                    </div>
                  </div>
                @if(!showMessageInput){
                  <div class="lil-action ml-3" (click)="showMessageInput = true">Write a message to the buyer</div>
                }@else {
                  <div class="m-2 ml-3">
                    <textarea
                      [(ngModel)]="message"
                      [placeholder]="'Message to ' +locations[fulfillment.fulfilledToLocationId].name"
                      rows="7"
                      class="border"
                    ></textarea>
                    <div class="flex justify-between">
                      <button mat-flat-button (click)="showMessageInput = false">Cancel</button>
                      <msh-button
                        [cta]="'Send Message'"
                        (onClick)="sendMsg(fulfillment)"
                        [isLoading]="messageSending"
                        [disabled]="!message"
                        class=" min-w-60"
                      ></msh-button>
                    </div>
                  </div>
                }
              </div>
              @if(interactions()[fulfillment.id] && interactions()[fulfillment.id].show){
                <div class="mt-6">
                  @for(entry of interaction.entries; track entry.id){
                    <msh-interaction-entry [isBuyer]="false" [interaction]="entry"></msh-interaction-entry>
                  }
                </div>
              }
            }
          </div>
        }
      }
    }
    </div>
  }
  `,
  styles: `
.dnd .msh-drop-list {
  border-style: dashed;
}  
.cdk-drag-preview .msh-item-image {
  box-sizing: border-box;
  border: solid 1px #666;
}
.cdk-drag-preview  {
  color: #666;
}
.cdk-drag-placeholder {
  opacity: 0.25;
}
  `
})
export class FulfillmentOrderDetailsComponent extends Base<FulfillmentOrderDetailsComponent> implements OnChanges {
  @Input() order!: OrderPublic
  @Input() fulfillments!: Fulfillment[]
  @Input() takingAction = false;
  @Input() ctaMap!:  {[status in FulfillmentStatusType]?: ButtonDisplay } 
  @Input() fulfillmentStatusMap: {[statusId: string]: Status} = {}
  @Output() onActionTaken: EventEmitter<Fulfillment> = new EventEmitter();
  @Input() buyerReviews: {[fulfillmentId: string]: ReviewForEdit} = {};
  @Input() sellerReviews: {[fulfillmentId: string]: ReviewForEdit} = {}
  @Output() onOpenReviewDialog: EventEmitter<ReviewForEdit> = new EventEmitter();
  @Output() requestRehydrate: EventEmitter<void> = new EventEmitter();
  location!: LocationPublic;
  locations:  {[locationId: string]: LocationPublic} = {}; 
  interactions: Signal<{[fulfillmentId: string]: InteractionView}> = toSignal( inject(Store).select(interactionsFeature.selectInteractionsByFulfillmentId)) as Signal<{[fulfillmentId: string]: InteractionView}>;
  unregisteredParcelCount = 0;
  updatedFulfillments: Fulfillment[] = [];
  message = "";
  messageSending = false;
  gettingInteractionsMap: {[fulfillmentId: string]: boolean} = {};
  fulfillmentParcelsToAdd: {[fulfillmentId: string]: OrderItem[]} = {};
  showMessageInput = false;
  managementMode: "Manage" | "Activate" | "" = "Manage";
  functions = inject(Functions);
  savingFulfillmentUpdates = false;
  finishingReconfiguration = false;
  managementModeNeeded = false;
  markAsReceivedLoading = false;

  constructor(
    private store: Store,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private orderService: OrderService,
  ) {
    super();
    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(async locations => {
      this.locations = locations as {[locationId:string]: LocationPublic}
    })
    this.store.select(accountFeature.selectLocation).pipe(take(1)).subscribe(location => {
      if(location) this.location = location;
    })
    // scroll to window to top
    window.scrollTo({top:0, behavior: 'smooth'})
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['order']){
      const nonArchivedOrCompletedFulfillments = this.order.fulfillments_on_order.filter(f => f.statusId !== 'archived' && ( !f.trackingNumber || f.trackingNumber === ''))
      if(nonArchivedOrCompletedFulfillments.length === 1){
        this.toggleInteraction(nonArchivedOrCompletedFulfillments[0].id!, true);
      }
      console.log({nonArchivedOrCompletedFulfillments, fulfillments_on_order: this.order.fulfillments_on_order})
      this.setupParcelDimensionsToBeAddedNote(nonArchivedOrCompletedFulfillments);
      this.setupManageModeNeeded(nonArchivedOrCompletedFulfillments);
    
    }
  }

  setupParcelDimensionsToBeAddedNote(nonArchivedOrCompletedFulfillments: Fulfillment[]){
    let existingFulfillmentParcelToAddKeysToDelete = Object.keys(this.fulfillmentParcelsToAdd);
    nonArchivedOrCompletedFulfillments.forEach(fulfillment => {
      existingFulfillmentParcelToAddKeysToDelete = existingFulfillmentParcelToAddKeysToDelete.filter(key => key !== fulfillment.id)
      if(!this.fulfillmentParcelsToAdd[fulfillment.id!]) this.fulfillmentParcelsToAdd[fulfillment.id!] = []
    })
    existingFulfillmentParcelToAddKeysToDelete.forEach(key => {
      delete this.fulfillmentParcelsToAdd[key];
    });
  }
  setupManageModeNeeded(nonArchivedOrCompletedFulfillments: Fulfillment[]){
    const nonArchivedOrCompletedOrderItems = nonArchivedOrCompletedFulfillments.reduce((acc, fulfillment) => {
      const itemsForFulfillment = this.order.orderItems_by_fulfillment ? this.order.orderItems_by_fulfillment[fulfillment.id!] : [];
      return [...acc, ...(itemsForFulfillment || [])]
    }, [] as OrderItem[])
    this.managementModeNeeded = nonArchivedOrCompletedOrderItems.length > 1;
  }

  async manageParcelConfiguration(reset = false){
    if(reset){
      this.managementMode = 'Manage';
      return;
    }
    if(this.managementMode === 'Activate'){
      // activate
      this.savingFulfillmentUpdates = true;
      console.log({fulfillment: this.fulfillments, updatedFulfillments: this.updatedFulfillments})
      // 
      //  BRAKE UP TO SINGLE FULFILLMENTS AT A TIME AND MOVE THIS TO THE ACCEPT SHIPPING RATE DIALOG COMPONENT ONCE THAT COMPONENT IS BUILT OUT, AND PASS THE UPDATED FULFILLMENT INFO FROM THIS COMPONENT TO THE DIALOG COMPONENT
      //. ... actually keep it for empty fulfillments to force a save - but make sure this doesn't overwrite changes made in the popup
      const data:UpdateFulfillmentsBeforeShippingVariables = {
        fulfillments: this.updatedFulfillments,
        orderId: this.order.id!,
      }
      console.log({data})
      const callable = httpsCallable(this.functions, onCallFunctions.updateFulfillmentsBeforeShipping)
      const updates = await callable(data);
      console.log({updates})
      if(updates.data && updates.data){
        this.snackBar.open("Fulfillments activated successfully", "Close", {duration: 3000});
      }else{
        this.snackBar.open("Error activating fulfillments. Please try again.", "Close", {duration: 3000});
        return;
      }
      this.fulfillments = this.updatedFulfillments.map(fulfillment => {
        if(fulfillment.parcels_on_fulfillment.every(parcel=> parcel.orderItems_on_parcel.length === 0)){
          fulfillment.statusId = 'archived';
        }
        return fulfillment;
      });
      this.updatedFulfillments = [];  
      this.requestRehydrate.emit();
      this.savingFulfillmentUpdates = false;
      this.managementMode = 'Manage';
      return;
    }
    this.managementMode = 'Activate';
  }

  async markAsReceived(refund: any){
    this.markAsReceivedLoading = true
    const data: ConfirmDeleteDialogData = {
      class: "",
      closeText: "Restock",
      item: "Inventory Restock",
      info: [
        "Once the refund has processed the"
        ,"inventory will be restocked, unless you"
        ,"choose to skip and do it manually."
      ],
      action: "Skip",
    }
    const skipRestock = await lastValueFrom( this.dialog.open(ConfirmDeleteDialogComponent, {data}).afterClosed().pipe(take(1)));
    const completeReturnVars: CompleteReturnData = {
      refundId: refund.id,
      restockItems: !skipRestock, // default to false - ask user if they want to restock items after marking return as received
    }
     // call function to mark return as received and pass in whether or not to restock items - if restockItems is true, also restock inventory for returned items
    const callable = httpsCallable<CompleteReturnData, StartRefundResult>(this.functions, onCallFunctions.completeReturn);
    try {
      const result = await callable(completeReturnVars);
      if(result.data && result.data.success){
        if(!skipRestock){
          completeReturnVars.restockItems = true;
          this.snackBar.open("Inventory restocked successfully", "Close", {duration: 3000});
        }else{
          this.snackBar.open("Return marked as received.", "Close", {duration: 10000});
        }
      }else{
        this.snackBar.open("Error completing return. Please try again. " + result.data.message, "Close", {duration: 5000});
      }
      console.log({result});
    } catch(error) {
      console.error({error})
      this.snackBar.open("An error occurred while starting the refund process. Please try again.", "close", {duration: 5000})
    }
    this.markAsReceivedLoading = false;
  }

  async respondToFaultyClaim(response: RefundDetailsFaultyClaimResponse){
    // update refund and run mark as received....
    if(response.refund.id){
      const vars: RespondToFaultyClaimVariables = {
        refundId: response.refund.id,
        locationId: this.location.id,
        fulfillmentId: this.fulfillments.find(f => f.refunds_on_fulfillment.some(r => r.id === response.refund.id))?.id || '',
        messageToBuyer: response.messageToBuyer,
        acceptedAsFaulty: response.accepted,
        rejectedAsFaulty: !response.accepted
      }
      try {
        const result = await respondToFaultyClaim(vars);
        if(result.data && result.data.refund_update){
          this.snackBar.open("Response submitted successfully. You will be notified once the refund is processed.", "Close", {duration: 10000});
        }else{
          this.snackBar.open("Error submitting response. Please try again.", "Close", {duration: 5000});
          return;
        }
      } catch(error) {
        console.error({error})
        this.snackBar.open("An error occurred while submitting your response. Please try again.", "close", {duration: 5000})
        return;
      }
    }
  }


  onDrop(event: CdkDragDrop<OrderItem[]>, fulfillment: Fulfillment | null = null) {
    if(fulfillment){
      const item = event.previousContainer.data[event.previousIndex];
      const pastFulfillment = this.fulfillments.find(f => f.id === item.fulfillmentId);
      const pastParcel = pastFulfillment?.parcels_on_fulfillment.find(p => p.id === item.parcelId);
      let blankParcel = { length: 0, width: 0, height: 0, weight: 0,
        distanceUnit: 'in' as ShippingDistanceUnit,
        weightUnit: 'oz' as ShippingWeightUnit
      }
      const { length, width, height, weight, distanceUnit, weightUnit } = pastParcel || blankParcel ;
      console.log({ length, width, height, weight, distanceUnit, weightUnit });
      const id = uuidV4();
      item.parcelId = id;
      item.fulfillmentId = fulfillment.id;
      this.unregisteredParcelCount++;
      fulfillment.parcels_on_fulfillment.push({ id, fulfillmentId: fulfillment.id,
        name: '_is_new_', refundId: '', length, width, height, distanceUnit, weight, weightUnit, orderItems_on_parcel: [item],
      });
      console.log({msg: 'to new parcel', item, event});
      transferArrayItem(
        event.previousContainer.data,
        event.container.data || [],
        event.previousIndex,
        event.container.data?.length || 0,
      );
      return;
    }
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
    // FIXME Update in memory fulfillment object's shipmentIsBeingReconfigured property to true so that the UI updates to show the "Finish Configuring" button, and then update it back to false if the item is moved back out of the fulfillment again
      console.log({msg: 'between parcels', event, ful: this.fulfillments, updatedFulfillments: this.updatedFulfillments});
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.setFulfillmentUpdates();
    console.log({msg: 'updated fulfillments after drop', updatedFulfillments: this.updatedFulfillments})
  }

  async manageParcel(currentParcel: Partial<Parcel>, fulfillmentId: string,  isNew: boolean){ 
    // open create parcel dialog
    const { id, weight, weightUnit, height, length, width, distanceUnit, shippingProcessorParcelId } = currentParcel;
    const data: ManageParcelData = {  parcelId: id || uuidV4(), name:'', weight, weightUnit, height, length, width, distanceUnit, shippingProcessorParcelId }
    const dialog = this.dialog.open(ManageParcelDialogComponent, { data, });
    const callable = httpsCallable<GetShippingRateInfoVariables,GetShippingRateInfoData>(this.functions, onCallFunctions.getShippingRateInfo);
    const vars: GetShippingRateInfoVariables = {
      rateId: this.fulfillments.find(f => f.id === fulfillmentId)?.rateId || ''
    }
    const shippingRateInfo = await callable(vars);;
    console.log({shippingRateInfo})
    let shipmentIsBeingReconfigured = true;
    const parcelDimensions: Partial<ListingPublic & {id: string, shippingProcessorParcelId: string}> = await lastValueFrom(dialog.afterClosed().pipe(take(1)));
    console.log({parcelDimensions})
    if(parcelDimensions){
      // save parcel info to backend
      if(!parcelDimensions.weight || !parcelDimensions.length || !parcelDimensions.width || !parcelDimensions.height){
        this.snackBar.open("Please fill in all parcel dimensions and weight", "Close", {duration: 3000});
        return;
      }
      if(shippingRateInfo.data && shippingRateInfo.data.shipment.parcels){
        const matchingParcel = shippingRateInfo.data.shipment.parcels.find((p: any) => p.objectId === shippingProcessorParcelId);
        console.log({matchingParcel, parcelDimensions})
        if(matchingParcel &&
          parcelDimensions.weight === parseFloat(matchingParcel.weight) &&
          parcelDimensions.weightUnit === matchingParcel.massUnit &&
          parcelDimensions.height === parseFloat(matchingParcel.height) &&
          parcelDimensions.length === parseFloat(matchingParcel.length) &&
          parcelDimensions.width === parseFloat(matchingParcel.width) &&
          parcelDimensions.distanceUnit === matchingParcel.distanceUnit
        ) {
          shipmentIsBeingReconfigured = false;
        }
      }
      const parcelInfoToSave: UpsertParcelDimensionsVariables = {
        parcelId: id || uuidV4(),
        name: parcelDimensions.name || '',
        height: parcelDimensions.height!,
        length: parcelDimensions.length!,
        width: parcelDimensions.width!,
        weight: parcelDimensions.weight!,
        distanceUnit: parcelDimensions.distanceUnit!,
        weightUnit: parcelDimensions.weightUnit!,
        fulfillmentId,
        shipmentIsBeingReconfigured: shipmentIsBeingReconfigured, // TODO - add conclusion
      }

      try {
        const results = await upsertParcelDimensions(parcelInfoToSave);
        const fulfillmentBeingReconfigured = this.fulfillments.find(f => f.id === fulfillmentId);
        if(fulfillmentBeingReconfigured) fulfillmentBeingReconfigured.shipmentIsBeingReconfigured = shipmentIsBeingReconfigured;
        console.log(this.fulfillments)
        if(!results) this.snackBar.open("Error saving parcel dimensions. Please try again.", "Close", {duration: 3000});
      } catch(errors){
        console.error("Error saving parcel dimensions", errors);
        this.snackBar.open("Error saving parcel dimensions. Please try again.", "Close", {duration: 3000});
        return;
      }
      const fulfillmentIdx = this.fulfillments.findIndex(f => f.id === fulfillmentId);
      if(fulfillmentIdx < 0) {
        this.snackBar.open("Error finding fulfillment to update parcel info. Please refresh and try again.", "Close", {duration: 3000});
        return;
      }
      const parcelIdx = this.fulfillments[fulfillmentIdx].parcels_on_fulfillment.findIndex((p, idx) => p.id === currentParcel.id);
      if(parcelIdx >= 0){
        this.fulfillments[fulfillmentIdx].parcels_on_fulfillment[parcelIdx] = {
          ...this.fulfillments[fulfillmentIdx].parcels_on_fulfillment[parcelIdx],
          name: parcelDimensions.name || '',
          length: parcelDimensions.length!,
          width: parcelDimensions.width!,
          height: parcelDimensions.height!,
          weight: parcelDimensions.weight!,
          distanceUnit: parcelDimensions.distanceUnit!,
          weightUnit: parcelDimensions.weightUnit!,
        }
      }else{
        console.log("Adding new parcel to fulfillment", {currentParcel, parcelDimensions})
      }
      console.log("Parcel info to save",parcelDimensions,this.updatedFulfillments, this.fulfillments);
      this.setFulfillmentUpdates();
      if(isNew) this.unregisteredParcelCount--;
    }
  }

  setFulfillmentUpdates(){
    this.fulfillments.forEach(f => {
      f.parcels_on_fulfillment.forEach(p => {
        p.orderItems_on_parcel.forEach(oi => {
          oi.fulfillmentId = f.id;
          oi.parcelId = p.id;
        })
      })
    });
    this.updatedFulfillments = JSON.parse(JSON.stringify(this.fulfillments)); // deep clone
  }

  async toggleInteraction(fulfillmentId: string, open: boolean | null = null){
    this.gettingInteractionsMap[fulfillmentId] = true;
    const state = await lastValueFrom(this.store.select(interactionsFeature.selectInteractionsByFulfillmentId).pipe(take(1)));
    if(!state[fulfillmentId] || !state[fulfillmentId].show){
      const location = await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(take(1)));
      if(!location) {
        snackBarError(`Lost connection with your ${LOCATION_LABEL}. Please refresh.`, this.snackBar);
        return;
      }
      this.location = location;
      await this.orderService.hydrateSellerInteractions(fulfillmentId, location.id);
    }
    this.store.dispatch(InteractionsPageActions.toggleInteractionsShowing({fulfillmentId, open}));
    this.gettingInteractionsMap[fulfillmentId] = false;
  }

  actionButtonClicked(fulfillment: Fulfillment){
    this.onActionTaken.emit(fulfillment)
  }
  
  async sendMsg(fulfillment: Fulfillment){
    this.messageSending = true;
    const vars: SendMessageVariables = {
      buyerInitiated: false,
      fulfillmentId: fulfillment.id,
      buyerId: fulfillment.fulfilledToLocationId,
      sellerId: fulfillment.fulfilledByLocationId,
      buyerAlert: true,
      sellerAlert: false,
      isInitial: false,
      subject: "Message Sent",
      body: this.message,
    }
    const sendMessageRef = await sendMessage(vars);
    if(!this.location) {
      const loc =  await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(take(1)));
      if(loc) this.location = loc;
    }
    if(this.location && this.order.id) this.orderService.hydrateSellerInteractions(fulfillment.id, this.location.id);
    this.message = ""
    this.showMessageInput = false;
    this.messageSending = false;
  }

}
